import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PublicLayout from './components/PublicLayout';
import HomePage from './pages/HomePage';
import AuctionsPage from './pages/AuctionsPage';
import AuctionDetailPage from './pages/AuctionDetailPage';
import TwitchCallbackPage from './pages/TwitchCallbackPage';
import DiscordCallbackPage from './pages/DiscordCallbackPage';
import OverlayPage from './pages/OverlayPage';
import OracleMonitorOverlayPage from './pages/OracleMonitorOverlayPage';
import CoworkOverlayPage from './pages/CoworkOverlayPage';
import SubathonOverlayPage from './pages/SubathonOverlayPage';
import AuctionsPublicGate from './components/AuctionsPublicGate';

const App: React.FC = () => (
  <Routes>
    <Route path="/overlay/cowork/:overlayKey/:overlay" element={<CoworkOverlayPage />} />
    <Route path="/overlay/subathon/:overlayKey/:overlay" element={<SubathonOverlayPage />} />
    <Route path="/overlay/:overlayKey/:alertFilter" element={<OverlayPage />} />
    <Route path="/overlay/:overlayKey" element={<OverlayPage />} />
    <Route path="/oracle-monitor/:monitorKey" element={<OracleMonitorOverlayPage />} />
    <Route path="/" element={<PublicLayout />}>
      <Route index element={<HomePage />} />
      <Route element={<AuctionsPublicGate />}>
        <Route path="subastas" element={<AuctionsPage />} />
        <Route path="subastas/:id" element={<AuctionDetailPage />} />
      </Route>
    </Route>
    <Route path="/auth/twitch/callback" element={<TwitchCallbackPage />} />
    <Route path="/auth/discord/callback" element={<DiscordCallbackPage />} />
  </Routes>
);

export default App;
